<div class="bl-margin-bottom--16" [class.bl-disabled]="!field.enabled">
  <label class="bl-label bl-font-weight--800 bl-font-size--16">
    Select the pair(s) of applicants below that are married and both applying
  </label>

  <fieldset class="bl-margin-top--16">
    <div *ngFor="let joint of coBorrowers.jointApplicants; index as i; trackBy: trackByFn" class="bl-margin-top--5">
      <label
        class="bl-label bl-font-weight--800 bl-font-size--16"
        [class.bl-required]="(i===0) ? true : false">
        Married Pair
      </label>
      <div class="select-applicant-box">
        <div class="bl-select-wrap">
          <select class="bl-select bl-input"
            id="applicant--{{i}}"
            (blur)="focused = false;"
            (focus)="focused = true;"
            [disabled]="!field.enabled"
            [(ngModel)]="joint.parent"
            name="parent"
            [cuFieldState]="field">
            <option [ngValue]="null">Select an applicant</option>
            <option  *ngFor="let applicant of joint.unSelectedApplicantsForParents" [ngValue]="applicant">{{applicant.displayName}}</option>
          </select>
        </div>
        <div class="bl-select-wrap bl-margin-top--5">
          <select class="bl-select bl-input"
            id="applicant--{{i}}"
            (blur)="focused = false;"
            (focus)="focused = true;"
            [disabled]="!field.enabled"
            name="coApplicant"
            [(ngModel)]="joint.applicant"
            [cuFieldState]="field">
            <option [ngValue]="null">Select an applicant</option>
            <option  *ngFor="let applicant of joint.unSelectedApplicantsForApplicant" [ngValue]="applicant">{{applicant.displayName}}</option>
          </select>
        </div>
      </div>
    </div>
  </fieldset>


</div>


